<template>
  <Modal
    title="Payrun"
    :show-modal="modalTitle === 'Payrun'"
    @close="$emit('close-modal')"
  >
    <section id="modal-content">
      <h1 class="text-xl text-center">AvHris</h1>
      <p class="text-sm text-center">
        Periode
        <span class="text-blue-500">
          {{ payrun.payrun_period.periodic_month }}

          {{ payrun.payrun_period.periodic_years }}
        </span>
      </p>

      <section class="flex justify-between my-10">
        <div class="flex">
          <div
            class="flex items-center justify-center w-12 h-12 rounded-full bg-zinc-400"
          >
            <h2 class="text-white text-md">
              {{
                payrun.emp_id.emp_fullname.substr(0, 1) +
                payrun.emp_id.emp_fullname.substr(
                  payrun.emp_id.emp_fullname.indexOf(" ") + 1,
                  1
                )
              }}
            </h2>
          </div>
          <div class="ml-3.5">
            <h1 class="mb-0 text-base text-blue-400">
              {{ payrun.emp_id.emp_fullname }}
            </h1>
            <p class="text-sm text-gray-400">
              {{ payrun.emp_id.email }}
            </p>
          </div>
        </div>
        <div>
          <p class="text-sm">
            Payslip For :
            <span class="text-blue-500">
              {{
                formatDate(
                  payrun.payrun_period.periodic_start_date || "12-02-2023"
                )
              }}
              -
              {{
                formatDate(
                  payrun.payrun_period.periodic_end_date || "10-02-2023"
                )
              }}
            </span>
          </p>
        </div>
        <div>
          <p class="text-sm">
            Designation : {{ payrun.emp_id.emp_desid.des_name }}
          </p>
          <p class="text-sm">
            Departement : {{ payrun.emp_id.emp_depid.dep_name }}
          </p>
        </div>
      </section>
      <section>
        <p class="flex justify-between pb-2 text-sm border-b">
          Gaji Pokok
          <span>{{ formatCurrency(payrun.payrun_salary || 0) }}</span>
        </p>
        <p class="mt-6 text-sm text-center">Rincian Penghasilan</p>
        <div class="grid grid-cols-2 gap-6 mt-6">
          <section class="w-full">
            <p class="mb-3 text-sm text-center">Tunjangan</p>
            <p
              class="flex items-center justify-between px-4 py-1 mb-2 text-sm text-gray-400 bg-white"
              v-if="payrun.payrun_total_overtime > 0"
            >
              <span> Lembur / Overtime </span>
              <span>
                {{ formatCurrency(payrun.payrun_total_overtime || 0) }}
              </span>
            </p>
            <p
              v-for="(allowance, i) in payrun.payrun_allowance"
              :key="i"
              class="flex items-center justify-between px-4 py-1 mb-2 text-sm text-gray-400 bg-white"
            >
              <span>
                {{ allowance.name }}
                {{ allowance.percent ? `${allowance?.total}%` : "" }}
              </span>
              <span>
                {{
                  formatCurrency(
                    allowance.percent
                      ? (allowance.total / 100) * payrun.payrun_salary
                      : allowance?.total || 0
                  )
                }}
              </span>
            </p>
          </section>
          <section class="w-full">
            <p class="mb-3 text-sm text-center">Potongan</p>
            <p
              class="flex items-center justify-between px-4 py-1 mb-2 text-sm text-gray-400 bg-white"
            >
              <span> Potongan Absensi </span>
              <span>
                {{ formatCurrency(payrun.payrun_total_deduct_attendance || 0) }}
              </span>
            </p>
            <p
              v-for="(deduction, i) in payrun.payrun_deduction"
              :key="i"
              class="flex items-center justify-between px-4 py-1 mb-2 text-sm text-gray-400 bg-white"
            >
              <span>
                {{ deduction.name }}
                {{ deduction.percent ? `${deduction.total}%` : "" }}
              </span>
              <span>
                {{
                  formatCurrency(
                    deduction.percent
                      ? (deduction.total / 100) * payrun.payrun_salary
                      : deduction.total || 0
                  )
                }}
              </span>
            </p>
          </section>
        </div>
        <p class="flex justify-between pb-2 mt-8 text-sm border-b">
          Total Tunjangan
          <span>{{ formatCurrency(payrun.payrun_total_allowance || 0) }}</span>
        </p>
        <p class="flex justify-between pb-2 my-2 text-sm border-b">
          Total Potongan
          <span>
            {{ formatCurrency(payrun.payrun_total_deduction || 0) }}
          </span>
        </p>
        <p class="flex justify-between pb-2 my-2 text-sm border-b">
          Total Potongan Kehadiran
          <span>{{
            formatCurrency(payrun.payrun_total_deduct_attendance || 0)
          }}</span>
        </p>
        <p class="flex justify-between pb-2 my-2 border-b">
          Net payable salary<span>
            {{ formatCurrency(payrun.payrun_net_salary || 0) }}
          </span>
        </p>
      </section>
    </section>
    <template v-slot:footer>
      <section class="flex justify-end w-52">
        <Button
          class="w-24 py-2 text-white bg-gray-400 rounded-md"
          @click="$emit('close-modal')"
        >
          Close
        </Button>
      </section>
    </template>
  </Modal>
</template>

<script>
import Modal from "@/components/Modal";
export default {
  name: "ModalPayrunProcess",
  components: {
    Modal,
  },
  props: {
    payrun: {
      type: Object,
      required: true,
    },
    modalTitle: {
      type: String,
      required: true,
    },
  },
  methods: {
    formatCurrency(number) {
      const formatter = new Intl.NumberFormat("id-ID", {
        style: "currency",
        currency: "IDR",
        minimumFractionDigits: 0,
      });
      return formatter.format(Math.round(number));
    },
    formatDate(dateString) {
      const date = new Date(dateString);
      const options = { day: "numeric", month: "long" };
      return new Intl.DateTimeFormat("id-ID", options).format(date);
    },
  },
};
</script>
